export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/sync.worker.b50e4123.worker.js");
}
